import { 
    GET_MERAKI_FIREWALL_AUTOMATION_LOGS,
    POST_MODIFY_MERAKI_FIREWALL_SCHEDULE,
    CANCEL_MERAKI_FIREWALL_SCHEDULE,
    GET_MERAKI_FIREWALL_AUTOMATION_RITS,
    POST_MERAKI_FIREWALL_FILE_COMPARE,
    GET_MERAKI_FIREWALL_FILE_COMPARE_LOGS
} 
from "./actionTypes";

export const getMerakiFirewallAutomationLogsInit = (startDate, endDate, offset) => ({
    type: GET_MERAKI_FIREWALL_AUTOMATION_LOGS.INIT,
    startDate, endDate, offset
});

export const getMerakiFirewallAutomationLogsSuccess = automationLogs => ({
    type: GET_MERAKI_FIREWALL_AUTOMATION_LOGS.SUCCESS,
    payload: automationLogs
});

export const getMerakiFirewallAutomationLogsFailure = errorMessage => ({
    type: GET_MERAKI_FIREWALL_AUTOMATION_LOGS.ERROR,
    payload: errorMessage
});
 
export const postModifyMerakiFirewallScheduleInit = (modifiedSchedule) => ({
    type: POST_MODIFY_MERAKI_FIREWALL_SCHEDULE.INIT,
    modifiedSchedule
});

export const postModifyMerakiFirewallScheduleSuccess = (response) => ({
    type: POST_MODIFY_MERAKI_FIREWALL_SCHEDULE.SUCCESS,
    payload: response
});

export const postModifyMerakiFirewallScheduleError = errorMessage => ({
    type: POST_MODIFY_MERAKI_FIREWALL_SCHEDULE.ERROR,
    payload: errorMessage
})
export const cancelMerakiFirewallScheduleInit = (cancelSchedule) => ({
    type: CANCEL_MERAKI_FIREWALL_SCHEDULE.INIT,
    cancelSchedule
});

export const cancelMerakiFirewallScheduleSuccess = (response) => ({
    type: CANCEL_MERAKI_FIREWALL_SCHEDULE.SUCCESS,
    payload: response

});

export const cancelMerakiFirewallScheduleFailure = (errorMessage) => ({
    type: CANCEL_MERAKI_FIREWALL_SCHEDULE.ERROR,
    payload: errorMessage,
});

export const getMerakiFirewallAutomationRitsInit = () => ({
    type: GET_MERAKI_FIREWALL_AUTOMATION_RITS.INIT
});

export const getMerakiFirewallAutomationRitsSuccess = rits => ({
    type: GET_MERAKI_FIREWALL_AUTOMATION_RITS.SUCCESS,
    payload: rits
});

export const getMerakiFirewallAutomationRitsFailure = errorMessage => ({
    type: GET_MERAKI_FIREWALL_AUTOMATION_RITS.ERROR,
    payload: errorMessage
});

export const postMerakiFirewallFileCompareInit = (formData) => ({
    type: POST_MERAKI_FIREWALL_FILE_COMPARE.INIT,
    formData
});

export const postMerakiFirewallFileCompareSuccess = response => ({
    type: POST_MERAKI_FIREWALL_FILE_COMPARE.SUCCESS,
    payload: response
});

export const postMerakiFirewallFileCompareError = errorMessage => ({
    type: POST_MERAKI_FIREWALL_FILE_COMPARE.ERROR,
    payload: errorMessage
});

export const getMerakiFirewallFileCompareLogsInit = () => ({
    type: GET_MERAKI_FIREWALL_FILE_COMPARE_LOGS.INIT
})

export const getMerakiFirewallFileCompareLogsSuccess = response => ({
    type: GET_MERAKI_FIREWALL_FILE_COMPARE_LOGS.SUCCESS,
    payload: response
})

export const getMerakiFirewallFileCompareLogsError = errorMessage => ({
    type: GET_MERAKI_FIREWALL_FILE_COMPARE_LOGS.ERROR,
    payload: errorMessage
})


